import React from 'react';
export function UrgencyBanner() {
  return <div className="bg-brand-forest text-brand-paper py-2.5 px-4 text-center" data-id="element-190">
      <p className="text-[11px] sm:text-sm font-bold uppercase tracking-wide leading-tight" data-id="element-191">
        ⚡ OFERTA DE LANZAMIENTO:{' '}
        <span className="text-brand-terracotta-light" data-id="element-192">50% DE DESCUENTO</span>{' '}
        DISPONIBLE SOLO POR HOY.
      </p>
    </div>;
}